import { render, staticRenderFns } from "./verification_detail.vue?vue&type=template&id=5261532f&scoped=true"
import script from "./verification_detail.vue?vue&type=script&lang=js"
export * from "./verification_detail.vue?vue&type=script&lang=js"
import style0 from "./verification_detail.vue?vue&type=style&index=0&id=5261532f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5261532f",
  null
  
)

export default component.exports